import React from 'react';
import AddLicensePlateModal from '../add-license-plate-modal';
import ChangeVehicleModal from '../change-vehicle-modal';
import { toggleModal } from 'store/parking-pass/parking-pass-actions';
import { useSelector, useDispatch } from 'react-redux';
import { CHANGE_VEHICLE } from 'store/parking-pass/parking-pass-reducer';
const ChangeVehicleModalWrapper = ({ reservation, activeStatus, }) => {
    const dispatch = useDispatch();
    const handleClose = () => {
        dispatch(toggleModal({ modal: CHANGE_VEHICLE }));
    };
    const isOpen = useSelector((store) => store.parkingPass.modals[CHANGE_VEHICLE]);
    if (reservation?.partner?.updateVehicleEnabled === false) {
        return (<AddLicensePlateModal reservation={reservation} onClose={handleClose} isOpen={isOpen} activeStatus={activeStatus}/>);
    }
    return (<ChangeVehicleModal reservation={reservation} onClose={handleClose} isOpen={isOpen} activeStatus={activeStatus}/>);
};
export default ChangeVehicleModalWrapper;
